var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "229px",
    height: "178px",
    viewBox: "0 0 229 178",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "undraw_Location_search_re_ttoj") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-8-Copy-38",
    transform: "translate(-69.000000, -161.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_Location_search_re_ttoj",
    transform: "translate(69.000000, 161.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E6E6E6",
    cx: 130.5,
    cy: 77.5,
    r: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.367294,89.307101 L143.751426,79.6877007 C145.240601,77.3705887 145.728406,74.5489958 145.103638,71.8661505 C144.47887,69.1833052 142.794778,66.8678649 140.435278,65.4476723 C135.875961,62.7230024 129.990278,63.9460517 126.892889,68.2617907 C124.057334,72.2390904 124.442892,77.6700331 127.811873,81.2065312 C131.180855,84.7430292 136.584959,85.3896311 140.692645,82.7477172 L150.308513,92.3671175 C151.153337,93.211306 152.522187,93.2109102 153.366522,92.3662332 C154.210858,91.5215563 154.211203,90.1522039 153.367294,89.307101 Z M140.333579,79.3286173 C137.876671,81.7864962 134.026309,82.1659101 131.137231,80.2348239 C128.248152,78.3037377 127.12501,74.5999885 128.454675,71.3886503 C129.78434,68.177312 133.196481,66.352792 136.60436,67.030898 C140.012239,67.709004 142.466716,70.7008731 142.466716,74.1767906 C142.469207,76.1095883 141.701518,77.9636704 140.333579,79.3286173 L140.333579,79.3286173 Z",
    id: "Shape",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.934337,103.809173 C248.890983,131.333458 176.545893,171 118.089296,171 C59.6326992,171 19.1898694,140.265437 12.2442557,103.809173 C-4.59647353,15.4150177 155.731337,-40.7678199 118.089296,36.618333 C63.2216763,149.417598 204.280441,82.1332023 223.934337,103.809173 Z",
    id: "Path",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.934337,110.809173 C237.890983,138.333458 165.545893,178 107.089296,178 C48.6326992,178 8.18986937,147.265437 1.24425567,110.809173 C-15.5964735,22.4150177 144.731337,-33.7678199 107.089296,43.618333 C52.2216763,156.417598 193.280441,89.1332023 212.934337,110.809173 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6842376,45.8644479 C17.3020439,45.0986632 3.82466649,41.3470351 4.00172461,37.3234408 C4.10787844,34.9111628 9.02720667,32.9713787 17.4982863,32.0016859 C17.5807788,31.9916848 17.6623023,32.0266782 17.7119077,32.0933815 C17.7615132,32.1600848 17.7715938,32.2482694 17.7383227,32.3244574 C17.7050516,32.4006454 17.6335306,32.4531539 17.5509116,32.4620488 C9.57115588,33.3755921 4.55669351,35.2461851 4.46437969,37.3438201 C4.30426441,40.9823569 18.1525665,44.6723074 34.7046028,45.401518 C51.256639,46.1307285 65.3754732,43.6728984 65.5355861,40.0343547 C65.628282,37.927904 60.7663029,35.6171003 52.8469226,34.0039028 C52.765649,33.9875889 52.6992889,33.929053 52.672924,33.8504195 C52.6465592,33.771786 52.6642112,33.6850494 52.7192082,33.6229932 C52.7742053,33.5609369 52.8581583,33.5330267 52.939336,33.5498118 C61.3450177,35.2621159 66.1048142,37.6330702 65.9982482,40.0547362 C65.821197,44.0783351 52.0664313,46.6302326 34.6842376,45.8644479 Z",
    id: "Path",
    fill: "#FEC532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,47 C21.9780305,52.9036676 27.741885,56.7071629 34.129609,56.9838393 C40.5173331,57.2605157 46.5633997,53.9685527 50,48.342727 C39.650896,48.4882813 29.301949,48.0400293 19,47 L19,47 Z",
    id: "Path",
    fill: "#FEC532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0749754,43.452593 C54.4979634,36.2582235 52.0550515,28.3339987 45.987025,23.7047313 C39.9189986,19.0754639 31.5558009,18.7557612 25.1452046,22.9080041 C18.7346083,27.060247 15.6816384,34.7743789 17.5369365,42.1322959 C28.9434906,44.0491185 40.5530619,44.4929215 52.0749754,43.452593 L52.0749754,43.452593 Z",
    id: "Path",
    fill: "#FEC532"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 39,
    cy: 29,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 28.5,
    cy: 35.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#1A91D7",
    cx: 81.5,
    cy: 33.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E6E6E6",
    cx: 28.5,
    cy: 105.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E6E6E6",
    cx: 126.5,
    cy: 153.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E6E6E6",
    cx: 35.5,
    cy: 79.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E6E6E6",
    cx: 93.5,
    cy: 131.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E6E6E6",
    cx: 198.5,
    cy: 125.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E6E6E6",
    cx: 165.5,
    cy: 145.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E6E6E6",
    cx: 131.5,
    cy: 120.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E6E6E6",
    cx: 86.5,
    cy: 51.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E6E6E6",
    cx: 92.5,
    cy: 17.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E6E6E6",
    cx: 89.5,
    cy: 162.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E6E6E6",
    cx: 54.5,
    cy: 147.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E6E6E6",
    cx: 164.5,
    cy: 122.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 35,
    cy: 53,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,84.3927263 C82,90.7085363 72.1569866,105.425415 69.2804776,109.59142 C69.1042761,109.847099 68.8122022,110 68.5,110 C68.1877978,110 67.8957239,109.847099 67.7195224,109.59142 C64.8430134,105.425423 55,90.7085363 55,84.3927263 C55,76.9961278 61.0441559,71 68.5,71 C75.9558441,71 82,76.9961278 82,84.3927263 L82,84.3927263 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FEC532",
    cx: 69,
    cy: 84,
    r: 7
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 69,
    cy: 116.5,
    rx: 8,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.444075,74.3209704 C190.385727,74.4364653 190.336395,74.5564744 190.296538,74.679882 L179.299479,77.7974309 L177.317727,75.8187644 L174,78.4799126 L177.174655,82.3306062 C177.70147,82.9696063 178.578464,83.1771115 179.32717,82.8399121 L191.206452,77.4897716 C192.031632,78.0741492 193.125133,78.0766 193.952821,77.4959268 C194.780509,76.9152536 195.169671,75.872625 194.930216,74.8773267 C194.69076,73.8820283 193.872654,73.1417482 192.875512,73.0180858 C191.87837,72.8944234 190.910264,73.4131833 190.44408,74.3209704 L190.444075,74.3209704 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.610306,78.4615721 L174.584256,81.7747895 C174.352457,81.9655435 174.053609,82.0401711 173.765586,81.9792255 C173.477563,81.91828 173.228895,81.7277979 173.08438,81.457416 L170.582208,76.7752456 C169.63905,75.4793388 169.865696,73.6208257 171.088909,72.6202605 C172.312122,71.6196952 174.070468,71.8545218 175.019956,73.1452504 L178.687513,76.8463372 C178.899937,77.0608331 179.013537,77.3624684 178.998711,77.6726418 C178.983884,77.9828152 178.842101,78.2708039 178.610306,78.4615626 L178.610306,78.4615721 Z",
    id: "Path",
    fill: "#F9A826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.291773,73.0660891 L195.563658,75.0112722 C195.936172,75.1809046 196.10229,75.6240462 195.934701,76.0010718 L195.428928,77.1388455 C195.552772,77.195701 195.608024,77.3430906 195.552609,77.4687795 L195.350299,77.9238885 C195.294124,78.0492383 195.148486,78.1051597 195.024296,78.0490659 L194.821986,78.5041749 C194.945838,78.5610296 195.001091,78.7084287 194.945667,78.8341208 L194.743357,79.2892298 C194.687184,79.4145736 194.541554,79.4704943 194.417368,79.4144072 L191.6862,85.55838 C191.518595,85.9353983 191.080748,86.1035269 190.708227,85.9339121 L186.436343,83.988729 C186.06383,83.8190955 185.897711,83.3759557 186.065297,82.9989293 L190.3138,73.4416188 C190.481406,73.0646004 190.919253,72.8964725 191.291773,73.0660891 L191.291773,73.0660891 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.396869,83.3775468 L190.656557,84.9371146 C190.996588,85.0986124 191.395578,84.938414 191.550059,84.5783651 L193.055607,81.020772 L193.578562,79.7875594 L194.941089,76.56877 C195.092632,76.20824 194.941797,75.7853646 194.603405,75.6220585 L193.578562,75.131275 L191.341313,74.0625168 C191.001337,73.901195 190.602606,74.0628308 190.450215,74.4237466 L189.132241,77.5354226 L187.63139,81.078068 L187.059194,82.4308496 C186.907129,82.7913568 187.058102,83.214622 187.396869,83.3775468 L187.396869,83.3775468 Z",
    id: "Path",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFB8B8",
    points: "181.000442 126 183.710583 125.999767 185 115 181 115.000233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,125.000252 L185.496766,125 L185.496994,125 C186.426047,125 187.317057,125.408086 187.974002,126.134559 C188.630947,126.861032 189,127.846352 189,128.873749 L189,128.999632 L180.000173,129 L180,125.000252 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFB8B8",
    points: "188.000442 126 190.710583 125.999767 192 115 188 115.000233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,125.000252 L192.496766,125 L192.496994,125 C193.426047,125 194.317057,125.408086 194.974002,126.134559 C195.630947,126.861032 196,127.846352 196,128.873749 L196,128.999632 L187.000173,129 L187,125.000252 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.555323,100.528752 C168.786689,104.176131 172.190507,106.647414 176.04241,106.690656 L176.185039,106.692954 C177.640864,106.734324 179.349825,106.26546 181.026557,105.592042 C184.338577,104.261294 187.519541,102.130719 188.363629,101.544638 L186.933075,115.286504 L186.353467,120.857717 C186.323862,121.149173 186.418942,121.439551 186.615229,121.657149 C186.811517,121.874747 187.090715,121.999281 187.383881,122 L190.955777,122 C191.426834,122 191.838798,121.683 191.95856,121.227752 L197.855866,98.7843137 C198.214716,97.4214493 197.894499,95.969297 196.99566,94.8833643 C196.096821,93.7974316 194.729468,93.2107444 193.322507,93.3073332 L181.072603,94.1462328 L181.92815,90.7262803 L170.993807,90 L170.961688,90.0229836 C170.699454,90.213747 170.444181,90.4137039 170.200366,90.6228543 C169.590751,91.1380089 169.050347,91.7297605 168.59259,92.3833944 C166.930325,94.763978 166.542681,97.8080287 167.555323,100.528752 L167.555323,100.528752 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.558355,100.226303 C168.796433,103.909928 172.218801,106.40577 176.091698,106.449441 C177.898679,105.531528 179.642386,104.493178 181.311115,103.341361 L181.103008,105.33991 L179.289994,122.846366 C179.260227,123.140718 179.355825,123.433982 179.553182,123.653742 C179.75054,123.873503 180.031259,123.999274 180.326023,124 L183.917386,124 C184.39101,124 184.80522,123.67985 184.925634,123.220078 L187.041721,115.130712 L190.855081,100.553605 C191.215886,99.1771971 190.893924,97.7106138 189.990186,96.6138896 C189.086449,95.5171653 187.711643,94.9246478 186.297015,95.0221964 L173.980349,95.8694327 L174.840558,92.415494 L168.601258,92 C166.929939,94.4042442 166.54019,97.4785453 167.558355,100.226303 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.329593,91.573815 L170.244269,91.5637914 L168.265375,82.0565246 C168.248437,81.9740051 166.630693,73.7735193 171.590129,69.4864373 L171.676445,68.8996883 C171.721182,68.5957993 171.899911,68.3263119 172.165508,68.1622807 C172.431104,67.9982494 172.756909,67.9561395 173.057017,68.0470538 L177.729143,69.4631033 C178.278736,69.6285354 178.596627,70.1884502 178.449355,70.7316434 L177.995183,72.4197277 C178.624954,73.1423799 186.038134,81.8633706 183.455909,88.5822433 L182.299406,93 L170.329593,91.573815 Z",
    id: "Path",
    fill: "#18683E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.296709,83.475557 C189.188492,83.5442121 189.085812,83.6213655 188.989625,83.7062996 L177.922926,80.7105622 L177.199424,78 L173,78.566378 L173.818361,83.4903959 C173.954163,84.3075087 174.608547,84.9361477 175.424497,85.0333428 L188.370699,86.5754789 C188.791768,87.4994715 189.735903,88.0643269 190.741928,87.9941336 C191.747952,87.9239404 192.60594,87.2333457 192.896796,86.25968 C193.187651,85.2860143 192.850681,84.2324519 192.050484,83.6136198 C191.250286,82.9947876 190.153838,82.9398171 189.296714,83.4755593 L189.296709,83.475557 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.128902,81.2874305 L172.126271,81.9910587 C171.838247,82.0315669 171.548341,81.9331736 171.332096,81.7215186 C171.115851,81.5098636 170.994688,81.2059115 171.000179,80.8888676 L171.095581,75.3988713 C170.908799,73.7419423 171.985186,72.232439 173.502103,72.024015 C175.019019,71.8155909 176.404332,72.9868572 176.5993,74.6426612 L177.962438,79.9096176 C178.041328,80.2147927 177.994661,80.54235 177.834596,80.8069333 C177.674531,81.0715166 177.416923,81.2469188 177.1289,81.2874329 L177.128902,81.2874305 Z",
    id: "Path",
    fill: "#18683E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFB8B8",
    cx: 175.5,
    cy: 60.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594395,61.3322911 L174.861298,60.0473629 C173.472679,65.4930701 175.925499,70 175.925499,70 L166.405391,65.7317142 L166.496063,64.2172632 L165.554042,65.246186 L164.200503,64.5282531 L164.021718,63.5459943 L163,63.7895902 L166.729505,57.2756734 C170.349067,51.0770925 175.611319,53.4436425 175.611319,53.4436425 C183.983031,53.0605868 182.960598,61.0103627 182.960598,61.0103627 L175.594395,61.3322911 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    transform: "translate(104.372991, 94.454049) rotate(-32.662420) translate(-104.372991, -94.454049) ",
    cx: 104.372991,
    cy: 94.4540485,
    rx: 2.84129627,
    ry: 11.0810529
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIllustration);
export default __webpack_public_path__ + "static/media/error_illustration.5633a3253498b8602aa78a8cd85d3954.svg";
export { ForwardRef as ReactComponent };